const hideFormFields = function (formName) {

    const testformular = document.querySelector(`form[name="${formName}"]`);
    if (!testformular) return;

    // Alle Elemente innerhalb des Formulars sammeln, die ein data-hidden-if Attribut besitzen.
    // Aus jedem Element erzeugen wir ein Array mit: [conditionString, element, label?, labelParent?]
    const hiddenIf = Array.from(testformular.querySelectorAll('[data-hidden-if]')).map(el => {
        const parent = el.parentElement;
        // Wenn das Element ein DIV ist, wird das zugehörige <label> als Label im selben Parent gesucht.
        // Sonst (bei Inputs etc.) suchen wir das label über das for-Attribut des Elements.
        const label = el.nodeName === 'DIV'
            ? parent.querySelector('label')
            : document.querySelector(`label[for=${el.id}]`);

        // Falls kein label gefunden wurde, speichern wir nur Bedingung und Element
        if (!label) return [el.dataset.hiddenIf, el];
        // Sonst speichern wir noch label und das Parent-Element des Labels (zum Ausblenden ganzer Zeile)
        return [el.dataset.hiddenIf, el, label, label.parentElement];
    });

    const elementCache = [];

    const getElementValue = function (elementName) {
        const cachedElement = elementCache[elementName];
        if (cachedElement) {
            return cachedElement.nodeName === 'DIV'
                ? cachedElement.querySelector('input:checked')?.value + ''
                : cachedElement.value + '';
        }
        // Sucht das Element per name="formName[elementName]"
        const element = testformular.querySelector(`[name*="[${elementName}]"]`);
        // Special-case Radio: Script geht davon aus, dass das radio-Input ein Kind des selben Parent ist
        if (element.type === 'radio') {
            const radioElement = element.parentElement;
            elementCache[elementName] = radioElement;

            return radioElement.querySelector(`input:checked`)?.value + '';
        }

        elementCache[elementName] = element;
        return element.value + '';
    }

    /**
     *
     * @param condition
     * @returns {boolean}
     */
    const resolveCondition = function (condition) {
        const trueOrFalse = condition.match(/^([\s!]*)\b(true|false)\b\s*$/);
        if (trueOrFalse) {
            const truth = trueOrFalse[2] === 'true';
            return trueOrFalse[1].replace(/\s+/g, '').length % 2 ? !truth : truth;
        }

        const comparison = condition.match(/\s*([\w-%]+)\s*([!=<>]+)\s*([\w-%\s]+)\s*/);
        if (!comparison) throw new Error(`"${condition}" ist keine gültige Bedingung`);

        const [, left, operator, right] = comparison;

        const valueLeft = left.at(0) === '%' ? getElementValue(left.slice(1, -1)) : left;
        const valueRight = right.at(0) === '%' ? getElementValue(right.slice(1, -1)) : right;

        if (operator === '==') return valueLeft === valueRight;
        if (operator === '!=') return valueLeft !== valueRight;
        if (operator === '<=') return valueLeft <= valueRight;
        if (operator === '>=') return valueLeft >= valueRight;
        if (operator === '<') return valueLeft < valueRight;
        if (operator === '>') return valueLeft > valueRight;
        throw new Error(`"${operator}" ist kein gültiger Operator`);
    }

    const splitAndOr = function (condition) {
        return condition
            .split('||')
            .map(el => el
                .trim()
                .split('&&')
                .every(el => resolveCondition(el.trim()))
            )
            .some(el => el);
    }

    const findBracket = function (condition) {

        const result = condition.match(/\(([^()]+)\)/);

        if (!result) return splitAndOr(condition.trim());

        const [withBrackets, inner] = result;

        const outer = condition.split(withBrackets)
        if (outer.length > 2) {
            outer[1] = outer.slice(1).join(withBrackets);
            outer.splice(2)
        }

        return findBracket(outer.toSpliced(1, 0, splitAndOr(inner.trim())).join(''));
    };

    const controlHide = function () {

        hiddenIf.forEach(el => {
            const elementAndLabel = el.slice(1);
            try {
                findBracket(el[0])
                    ? elementAndLabel.forEach(el => el.classList.add('hidden'))
                    : elementAndLabel.forEach(el => el.classList.remove('hidden'));
            } catch (err) {
                console.error(err);
            }
        })
    };

    // Aufrufen beim Laden der Seite und bei jeder Eingabe im Formular
    window.addEventListener('load', controlHide);
    testformular.addEventListener('input', controlHide);
    testformular.addEventListener('change', controlHide);

}
export default hideFormFields;